import React from "react";
//#region types
import { PersonProps } from "models/propTypes/userProfilePropTypes";
import { CommonConstants } from "utils/constants";
//#endregion
//#region components
import ProfileImage from "./profileImage";
import { Grid, Tooltip } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const Person: React.FC<PersonProps> = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const profileImage = (
    <ProfileImage id={props.id} name={props.name} className={cssExports.listItemAvatar}></ProfileImage>
  );

  const name = props.id === undefined ? CommonConstants.Wint : props.name;

  const onClick = (e?: React.MouseEvent) => {
    if (props.href) e?.stopPropagation();
    if (props.onProfileClick) props.onProfileClick();
    props.href &&
      navigate(props.href, {
        state: { background: location },
      });
  };

  return (
    <Grid
      container
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent={props.hideUserName ? "center" : "flex-start"}
      style={{ flexWrap: "nowrap" }}
      className={clsx(props.className ?? cssExports.titleLink, cssExports.personContainer)}
    >
      {!props.hideProfileImage && (
        <Grid item onClick={onClick} className={props.href ? cssExports.linkIcon : ""}>
          {props.hideUserName && name ? (
            <Tooltip
              disableInteractive
              placement="top"
              title={name}
              arrow
              classes={{
                tooltip: cssExports.tooltip,
                popper: cssExports.tooltipPopper,
                arrow: cssExports.tooltipArrow,
              }}
            >
              <Grid item>{profileImage}</Grid>
            </Tooltip>
          ) : (
            profileImage
          )}
        </Grid>
      )}
      {!props.hideUserName && (
        <Grid item className={clsx(cssExports.personName, cssExports.truncateString)}>
          <span className={props.href ? props.className ?? cssExports.linkText : ""} onClick={onClick}>
            {name}
          </span>
        </Grid>
      )}
    </Grid>
  );
};

export default Person;
